module.exports = __webpack_public_path__ + "img/small-yellow-circle.a1093196.svg";